import * as React from 'react';
import { compose } from 'recompose';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { skin, OemProps } from 'ui/styles/skin';
import { State } from 'reducers';
import { Shell } from './Shell';
import { getInitError } from 'selectors/appSelectors';
import { WarningTriangle } from 'ui/shapes';

import './App.css';
import 'ui/styles/oem/scrollBars.css';

const CatastrophicFailure = ({ text, styles }: { text: string } & OemProps) =>
    <div className="catastrophic-failure">
        <WarningTriangle
            className="symbol"
            width="128px"
            height="128px"
            style={ styles.FillForeground }
        />
        <div className="message">
            { text }
        </div>
    </div>
;

const RawApp = ({ initError, styles }: StateProps & OemProps) =>
    <div style={ styles.Workspace } id="app">
        { initError
            ? <CatastrophicFailure text={ initError.message } styles={ styles }/>
            : <Shell/>
        }
    </div>
;

type StateProps = {
    initError: Error | null;
};

const mapStateToProps = (state: State): StateProps => ({
    initError: getInitError(state),
});

export const App = compose<StateProps & OemProps, {}>(
    skin,
    withRouter,
    connect<StateProps, {}, {}>(mapStateToProps),
)(RawApp);



// WEBPACK FOOTER //
// ./src/ui/main/App.tsx